module.exports = __webpack_public_path__ + "static/media/BrandonGrotesque-Black.e9e721d0.otf";